module.exports = __webpack_public_path__ + "static/media/26_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_ESTAMPADO_02.494f260c.jpg";